import ApiException from "@rmp/core/exceptions/apiException";

export default class OfflineException extends ApiException {
	constructor(public readonly url: string) {
		super(`OfflineException: ${url}`);
	}
}
